define.alias("shared/components/shared/date-time-picker", "calendar/components/shared/date-time-picker");